export const tradingContest = {
  cyjyds: "参与交易大赛",
  jsjxmh: "解锁惊喜盲盒，赢超级大奖！",
  hdsj: "活动时间",
  mrjxsj: "每日00:00至23:59 UTC+8进行。",
  ckxxgz: "查看详细规则",
  wdjj: "我的奖金",
  jlkj: "距离开奖",
  cjjc: "超级奖池",
  jjmrzj: "奖金每日累计增加",
  kqxjd: "开启新阶段，奖励数量增加",
  dyjd: "第一阶段",
  dejd: "第二阶段",
  dsjd: "第三阶段",
  dsijd: "第四阶段",
  jrmhjj: "今日盲盒奖金",
  syjj: "剩余奖金",
  yblqje: "已被领取金额",
  tjmh: "特级盲盒",
  yjmh: "一级盲盒",
  ejmh: "二级盲盒",
  sjmh: "三级盲盒",
  jj: "奖金：",
  gs: "个",
  djdkrymh: "点击打开任意一个惊喜盲盒",
  kydk: "您今天可以打开",
  jxmh: "惊喜盲盒",
  dkmhxyxx: "打开一个盲盒需要 {amount}个星星。",
  xzyyxx: "您现在拥有{amount}个星星",
  xxqlsj: "星星清零时间：{date}  （请在星星清零前领取盲盒）",
  wdxx: "我的星星",
  xxhq: "星星获取",
  hqxxtj: "获取星星途径",
  yxhysxf: "永续合约：每{amount}U手续费获1颗星星",
  qqhysxf: "期权合约：每{amount}U交易额获得1颗星星",
  youxihysxf: "GameFi：每{amount}U交易额获得1颗星星",
  gxhd: "恭喜您已获得",
  jlydrzh: "该奖励已打入您的“{account}”",
  qzjzhck: "去趣投账户查看",
  bwcjjc: "币王超级奖池",
  qmxjyds: "全明星交易大赛",
  gbgbyb: "敢不敢来搏一把？",
  bwcjjcdnn: "币王超级奖池，每天{amount}%盲盒大奖随你拿！",
  cjjcqmxjys: "币王超级奖池全明星交易大赛奖池{amount}%每天加盲盒，",
  syyxbd: "随手一开以小搏大！",
  zgtk: "想登顶？来战个痛快！",
  zhyz: "每日奖池{amount}%积累至最后一战，",
  dfdj: "谁能拿下币王巅峰大奖？",
  gsjj: "币王超级奖池全明星交易大赛高手聚集，",
  qmxpk: "全明星PK见真章！",
  jymh: "交易、盲盒、冲榜，玩转币王赛场！",
  zzbzy: "永续合约、期权、GameFi、现货交易，四周玩法层层升级，周周不重样！",
  jlfh: "币王超级奖池全明星交易大赛，奖励丰厚等你名利双收英雄称王！",
  mh: "盲盒",
  cb: "冲榜",
  jy: "交易",
  syxxs: "剩余星星数",
  xxbhs: "星星变化数量",
  sjlx: "事件类型",
  jycp: "交易产品",
  jye: "交易额",
  myxgjl: "您还没有获得相关奖励哦",
  jyhd: "交易获得",
  ql: "清零",
  kqmh: "开启盲盒",
  yx: "GameFi游戏",
  bchdyjs: "本次活动已结束",
  gffjj: "本次大赛共发放奖金",
  kqmhsl: "开启盲盒数量",
  cjjcjj: "超级奖池奖金",
  cjjchjmd: "超级奖池获奖名单",
  jjdyyh: "奖金已打入用户资金账户",
  hdjj: "获得奖金",
  wff: "未发放",
  mhhjjl: "盲盒获奖记录",
  cjdjhjjl: "超级大奖获奖记录",
  jjse: "奖金数额",
  xhxxs: "消耗星星数",
  bwqmxgz: "币王全明星交易大赛活动规则",
  hdnr: "活动内容",
  hdnrgz: "币王超级奖池全明星交易大赛涵盖永续合约、期权合约、GameFi游戏及现货交易四大领域。活动分为四周，每周逐步解锁新的交易产品，让您在多维度的交易挑战中获得“星星”并赢取丰厚奖励。每日奖池{total}%用于盲盒抽奖，惊喜奖励即开即得！剩余的{amount}%累积至大赛结束，按交易排名瓜分最高奖励！",
  hdjd: "活动阶段",
  jbjs: "逐步解锁，四个周期竞赛升级",
  dyzq: "第一周期",
  kqyxhy: "开启永续合约交易，交易量越高，星星积分越多，奖池奖励越高！",
  dezq: "第二周期",
  jmqqjy: "加码期权合约交易，交易盈亏双向累积奖池，让您的星星数量再次升级。",
  dszq: "第三周期",
  cjgejc: "加入GameFi游戏，通过多元交易体验获取星星，冲击高额奖池。",
  dsizq: "第四周期",
  gfzzdj: "前三周盲盒奖池继续开放，现货交易榜单独设立，瓜分最终大奖！",
  jzszjs: "奖池奖金数值计算",
  jxmhgz1: "每日奖池的{amount}%分配至盲盒，100个盲盒即开即领，四个等级的奖品让您时刻体验惊喜。未领取奖励自动累积到次日奖池，让收益持续增长！特级盲盒、一级盲盒等每日刷新，超高中奖率等您来开！",
  mhfpmx: "每日总盲盒数{total}个，总占比奖池{amount}%。盲盒分配明细：",
  tjmhzb: "特级盲盒{total}个，占比 {amount}%奖池",
  yjmhzb: "一级盲盒{total}个，占比 {amount}%奖池",
  ejmhzb: "二级盲盒{total}个，占比 {amount}%奖池",
  sjmhzb: "三级盲盒{total}个，占比 {amount}%奖池",
  kmhxxyq: "开盲盒需要的星星数量要求：每日盲盒奖池金额/{text}",
  tips: "注意：所有盲盒对应奖励每日0点刷新，按前一日产生的各产品交易盈亏奖池+前一日开盒剩余金额重新计算，按以上等级与比例分的金额配到当日盲盒中。",
  mrjyyk: "总奖池根据永续合约、期权合约、GameFi三大板块交易每日交易盈亏。",
  mgyld: "每一个盈利单的{amount}% =盈利金额*{amount}%",
  mrjcljdjs: "每日奖池的{amount}%累积到活动结束，由四大交易产品的排行榜前三名瓜分，延续奖池比例分别为：永续合约40%，期权30%，GameFi 20%，现货10%。",
  yhhyyld: "例如：用户合约订单盈利1000U，则1000*{amount}%={total}U进入当日奖池",
  mgksd: "每一个亏损单的{amount}%=实际亏损金额（亏损-穿仓回补）*{amount}%",
  yhhyks: "例如：用户合约订单实际亏损1000U，则1000*{amount}%={total}U进入当日奖池",
  qqhyyld: "每一个盈利单的{amount}% =投注金额*赔率*{amount}%",
  qqyhddtz: "例如：用户期权订单投注100U，10秒周期盈利，则100*65%*{amount}%={total}U进入当日奖池",
  qqhyksd: "每一个亏损单的{amount}%=亏损金额*{amount}%",
  yhksjrjc: "例如：用户期权订单亏损100U，则100*{amount}%={total}U进入当日奖池",
  yxyld: "每一个盈利单的{amount}% =投注金额*赔率*{amount}%",
  yxddtz: "例如：用户gamefi订单投注100U，假设赔率2倍。盈利，则100*200%*{amount}%={total}U进入当日奖池",
  yxmgksd: "每一个亏损单的{amount}%=亏损金额*{amount}%",
  yhqqksd: "例如：用户期权订单亏损100U，则100*{amount}%={total}U进入当日奖池",
  daiding: "待定",
  yytz: "活动调整",
  kaiqi: "开启",
  xhjyjrpm: "现货交易加入排名",
  drjy: "当日交易 次日获得",

}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/zh.js